import { IApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const genplanSeoPageUrlSelector = (state: IApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}genplan/`;
};
